import React, {Component} from 'react';
import {connect} from 'react-redux';
import FJMenu from '../view/FJMenu';
import {FJResourceAction} from "../../../redux/action/FJRoot.action"

class FJMenuContainer extends Component {
  render() {
    let {menuTypeChange, showType, isResourceExpand,} = this.props;
    return (
      <FJMenu changeType={menuTypeChange}
              isResourceExpand={isResourceExpand}
              activePanelType={showType}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showType: state.resource.showType,
    isResourceExpand: state.resource.isResourceExpand,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    menuTypeChange: function (type, direction) {
      dispatch(FJResourceAction.setShowTypeAction(type, direction, true));
      dispatch(FJResourceAction.setLastTypeAction(type));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJMenuContainer);
